/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    DynamicListAddButton,
    DynamicListWrapperProps,
    requiredRule,
    ValidatedDropDownList,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { Trans, useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';
import { TradeOrgAddForm } from './TradeOrgChangeModal';

const TradeOrgContactsFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th className="w-45">
                        <Trans i18nKey="BackOfficeContactType" />
                    </th>
                    <th className="w-45">
                        <Trans i18nKey="BackOfficeContactValue" />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const TradeOrgContactsForm = ({
    contactTypes,
    contactTypesIsFetching,
    idx,
    idxRoot,
    formHasRole,
}: ValidatedDynamicListFormComponentProps & {
    idxRoot: number;
    contactTypes: DropDown[];
    contactTypesIsFetching: boolean;
    formHasRole: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <>
            <td>
                <ValidatedDropDownList<TradeOrgAddForm>
                    label={t('BackOfficeContactType')}
                    isClearable={false}
                    name={`contactFaces.${idxRoot}.contacts.${idx}.type`}
                    items={contactTypes}
                    isLoading={contactTypesIsFetching}
                    rules={{
                        required: requiredRule,
                    }}
                    disabled={!formHasRole}
                />
            </td>
            <td>
                <ValidatedInput<TradeOrgAddForm>
                    name={`contactFaces.${idxRoot}.contacts.${idx}.value`}
                    label={t('BackOfficeContactValue')}
                    rules={{
                        required: requiredRule,
                    }}
                    disabled={!formHasRole}
                />
            </td>
        </>
    );
};

export { TradeOrgContactsForm, TradeOrgContactsFormWrapper };
